import { getInvoiceList, getOcrDetail } from '../services';

export default {
  namespace: 'invoiceManage',
  state: {
    invoiceData: {
      data:[],
      pageNum: 1,
      pageSize: 10,
      total: 0,
    },
  },
  effects: {
    * GetInvoiceList ({ payload }, { call, put }) {
      return yield call(getInvoiceList, payload);
    },
    * GetOcrDetail ({ payload }, { call, put }) {
      return yield call(getOcrDetail, payload);
    },
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
